<template>
	<div class="right_column">
		<general-schedule
			:initialState="{dayCount: this.dayCount}"
			v-bind:doctorList="doctorList"
			v-bind:agendaList="agendaList"
			v-bind:updateAgenda="updateAgenda"
		/>
	</div>
</template>

<script>
	import GeneralSchedule from './components/GeneralSchedule.vue';
	import moment from 'moment';

	export default {
		name: 'GeneralSchedule',
		components: {
			'general-schedule': GeneralSchedule,
		},
		computed: {
			clinicId(){
				return this.$route.params.clinic;
			}
		},
		mounted() {
			this.getDoctorList();
		},
		data: () => ({
			dayCount: 7,
			doctorList: [],
			agendaList: [],
		}),
		methods: {
			getDoctorList() {
				this.$store.dispatch('worker/list', {clinic_id: this.clinicId, per_page: 100})
					.then(({ data }) => this.filterDoctorsByRole(data))
					.then(data => this.filterDoctorsByAvailability(data))
					.then(doctors => this.doctorList = doctors)
					.then(doctors => this.getAgendas(doctors))
					.then(this.getSpecialDaysForDoctors)
					.then(this.setDoctorsAgenda);
			},

			getAgendas(doctors, startDay = moment().format('DD-MM-YYYY')) {
				return Promise.all(doctors.map((doctor) => this.getAgenda(doctor, startDay)))
					.then(agendas => ({ agendas, doctors }));
			},

			updateAgenda(doctors = this.doctorList, startDay) {
				this.getAgendas(doctors, startDay)
					.then(this.getSpecialDaysForDoctors)
					.then(this.setDoctorsAgenda);
			},

			getSpecialDaysForDoctors({ doctors, agendas }) {
				return Promise.all(doctors.map(doctor => this.getSpecialDaysForDoctor(doctor._id)))
					.then(specialDays => ({ agendas, specialDays }));
			},

			setDoctorsAgenda({ agendas, specialDays }) {
				this.agendaList = agendas.map((agenda, index) => Object.assign(agenda, { special: specialDays[index].data }));
			},

			getSpecialDaysForDoctor(id) {
				return this.$store.dispatch('special/list', {worker_ids: [id]});
			},

			getAgenda(worker, startDay) {
				if (!worker || !worker._id) {
					return undefined;
				}

				return this.getSpecialSchedule(worker)
					.then(worker => this.getEvents(worker, startDay));
			},

			getSpecialSchedule(worker) {
				return this.$store.dispatch('special/list', { worker_ids: [worker._id] })
					.then(() => worker);
			},

			getEvents(worker, startDay) {
				return this.$store.dispatch('agenda/byDate', this.getRequestObjectForAgenda(worker, startDay));
			},

			getRequestObjectForAgenda(worker, startDay) {
				const start = this.convertDataFormat(startDay);
				return {
					begin: start,
					end: moment(start, 'YYYY-MM-DD').add(this.dayCount - 1, 'days').format('YYYY-MM-DD'),
					worker_ids: [worker._id],
				};
			},

			filterDoctorsByRole(workers) {
				const doctorRoles = ['doctor', 'doctor_admin', 'doctor_registrar'];

				return workers.filter((worker) => {
					return !!doctorRoles.find(role => worker.role_type === role);
				})
			},

			filterDoctorsByAvailability(workers) {
				return workers.filter(worker => +worker.blocked === 0);
			},

			convertDataFormat(date) {
				return moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')
			}
		}
	};
</script>

<style scoped>
	.right_column {
		/* 56px - header, 47px - top menu, 25px - bottom menu, 15px * 2 - padding */
		padding: 15px;
		height: calc(100vh - 128px);
		/*min-height: 80vmin;*/
	}
</style>



// WEBPACK FOOTER //
// GeneralSchedule.vue?b1fa0100